import React from 'react';
import { Check, Sparkles, X } from 'lucide-react';
import { Button } from './ui/button';

const Pricing = () => {
  const plans = [
    {
      name: 'ParamBhakt Plan (Premium)',
      price: '₹499',
      features: [
        { text: '900 voice minutes', isNegative: false },
        { text: 'Unlimited chat', isNegative: false },
        { text: 'Personal memory per deity (context retention)', isNegative: false },
        { text: 'Badge: "ParamBhakt"', isNegative: false },
        { text: 'Early access to new features', isNegative: false }
      ],
      isPopular: true
    },
    {
      name: 'Divine Bhakt Plan (Standard)',
      price: '₹149',
      features: [
        { text: 'No voice access', isNegative: true },
        { text: 'Unlimited chat', isNegative: false },
        { text: 'Badge: "Divine Bhakt"', isNegative: false }
      ],
      isPopular: false
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 right-1/4 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl cosmic-glow"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-4 text-white">
            Choose Your <span className="text-gradient">Spiritual Path</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Start your journey with a plan that suits you
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-stretch">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`divine-card p-8 relative transition-all duration-300 hover:scale-105 flex flex-col h-full ${
                plan.isPopular ? 'ring-2 ring-orange-500 scale-105 hover:scale-110' : ''
              }`}
            >
              {plan.isPopular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-4 py-1 rounded-full text-sm font-semibold flex items-center gap-1 shadow-lg">
                    <Sparkles className="w-4 h-4" />
                    Most Popular
                  </div>
                </div>
              )}
              
              <div className="text-center mb-6">
                <h3 className="font-serif text-2xl font-bold text-white mb-2">
                  {plan.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1">
                  <span className="text-5xl font-bold text-gradient">
                    {plan.price}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 flex-1">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    {feature.isNegative ? (
                      <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
                    ) : (
                      <Check className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                    )}
                    <span className={`${feature.isNegative ? 'text-gray-400' : 'text-gray-300'}`}>
                      {feature.text}
                    </span>
                  </li>
                ))}
              </ul>

              <Button
                className={`w-full py-6 text-lg rounded-full transition-all duration-300 mt-auto ${
                  plan.isPopular
                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white glow-effect'
                    : 'border-2 border-orange-500/50 text-white hover:bg-orange-500/10 backdrop-blur-sm'
                }`}
                variant={plan.isPopular ? 'default' : 'outline'}
              >
                Unlock Divine Connection
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;